import { AsyncStatus } from 'lib-shared-legacy-types';
import { handleActions } from 'redux-actions';


import { templatesActions } from '../../actions/templates';

const {
  templatesListAll,
  templatesListAllSucceeded,
  templatesListAllFailed,
  templatesAdd,
  templatesAddSucceeded,
  templatesAddFailed,
  templatesDelete,
  templatesDeleteSucceeded,
  templatesDeleteFailed,
  templatesUpdate,
  templatesUpdateSucceeded,
  templatesUpdateFailed,
  templatesRender,
  templatesRenderSucceeded,
  templatesRenderFailed,

  templatesGetSort,
  templatesGetSortSucceeded,
  templatesGetSortFailed,

  templatesSetSort,
  templatesSetSortSucceeded,
  templatesSetSortFailed,

  templatesOpenEditModal,
  templatesCloseEditModal,

  templatesOpenConfirmModal,
  templatesCloseConfirmModal,
} = templatesActions;

export type TemplatesStates = {
  templatesList: Array<any>;
  currentTemplate: any;
  meta: {
    list: AsyncStatus;
    add: AsyncStatus;
    get: AsyncStatus;
    delete: AsyncStatus;
    update: AsyncStatus;
    render: AsyncStatus;
    sortType: string;
  };
  ui: {
    isEditModalOpen: boolean;
    isConfirmModalOpen: boolean;
  };
};

const initialState: TemplatesStates = {
  templatesList: [],
  currentTemplate: null,
  meta: {
    list: 'succeeded',
    add: 'succeeded',
    get: 'succeeded',
    delete: 'succeeded',
    update: 'succeeded',
    render: 'succeeded',
    sortType: 'Most popular',
  },
  ui: {
    isEditModalOpen: false,
    isConfirmModalOpen: false,
  },
};

// Reducer
export const templates = handleActions<TemplatesStates, any>(
  {
    [templatesGetSort.toString()]: (state: TemplatesStates, action) => {
      return { ...state, meta: { ...state.meta, asyncStatus: 'loading' } };
    },

    [templatesGetSortSucceeded.toString()]: (
      state: TemplatesStates,
      action,
    ) => {
      return {
        ...state,
        meta: {
          ...state.meta,
          sortType: action.payload,
          asyncStatus: 'succeeded',
        },
      };
    },

    [templatesGetSortFailed.toString()]: (state: TemplatesStates, action) => {
      return { ...state, meta: { ...state.meta, asyncStatus: 'failed' } };
    },

    [templatesSetSort.toString()]: (state: TemplatesStates, action) => {
      return { ...state, meta: { ...state.meta, asyncStatus: 'loading' } };
    },

    [templatesSetSortSucceeded.toString()]: (
      state: TemplatesStates,
      action,
    ) => {
      return {
        ...state,
        meta: {
          ...state.meta,
          sortType: action.payload,
          asyncStatus: 'succeeded',
        },
      };
    },

    [templatesSetSortFailed.toString()]: (state: TemplatesStates, action) => {
      return { ...state, meta: { ...state.meta, asyncStatus: 'failed' } };
    },

    [templatesOpenEditModal.toString()]: (
      state: TemplatesStates,
      action: any,
    ) => {
      const currentTemplate = action.payload.template
        ? Object.assign({}, action.payload.template)
        : null;
      return {
        ...state,
        ui: { ...state.ui, isEditModalOpen: true },
        currentTemplate: currentTemplate,
      };
    },

    [templatesCloseEditModal.toString()]: (
      state: TemplatesStates,
      action: any,
    ) => {
      return {
        ...state,
        ui: { ...state.ui, isEditModalOpen: false },
        currentTemplate: null,
      };
    },

    [templatesOpenConfirmModal.toString()]: (
      state: TemplatesStates,
      action: any,
    ) => {
      const currentTemplate = action.payload.template
        ? Object.assign({}, action.payload.template)
        : null;
      return {
        ...state,
        ui: { ...state.ui, isConfirmModalOpen: true },
        currentTemplate: currentTemplate,
      };
    },

    [templatesCloseConfirmModal.toString()]: (
      state: TemplatesStates,
      action: any,
    ) => {
      return {
        ...state,
        ui: { ...state.ui, isConfirmModalOpen: false },
        currentTemplate: null,
      };
    },

    [templatesListAll.toString()]: (state: TemplatesStates, action: any) => {
      return { ...state, meta: { ...state.meta, list: 'loading' } };
    },

    [templatesListAllSucceeded.toString()]: (
      state: TemplatesStates,
      action: any,
    ) => {
      const templatesList = action.payload.data.templates.slice();
      return {
        ...state,
        meta: { ...state.meta, list: 'succeeded' },
        templatesList: templatesList,
      };
    },

    [templatesListAllFailed.toString()]: (
      state: TemplatesStates,
      action: any,
    ) => {
      return { ...state, meta: { ...state.meta, list: 'failed' } };
    },

    [templatesAdd.toString()]: (state: TemplatesStates, action: any) => {
      return { ...state, meta: { ...state.meta, add: 'loading' } };
    },

    [templatesAddSucceeded.toString()]: (
      state: TemplatesStates,
      action: any,
    ) => {
      const template = Object.assign({}, action.payload.data);
      const templatesList = state.templatesList.slice();

      templatesList.push(template);

      return {
        ...state,
        meta: { ...state.meta, add: 'succeeded' },
        ui: { ...state.ui, isEditModalOpen: false },
        templatesList: templatesList,
      };
    },

    [templatesAddFailed.toString()]: (state: TemplatesStates, action: any) => {
      return { ...state, meta: { ...state.meta, add: 'failed' } };
    },

    [templatesDelete.toString()]: (state: TemplatesStates, action: any) => {
      return { ...state, meta: { ...state.meta, delete: 'loading' } };
    },

    [templatesDeleteSucceeded.toString()]: (
      state: TemplatesStates,
      action: any,
    ) => {
      const templateListCopy = state.templatesList.slice();
      const templatesList = templateListCopy.filter(
        (x) => x.name !== action.payload.data.name,
      );
      return {
        ...state,
        meta: { ...state.meta, delete: 'succeeded' },
        ui: { ...state.ui, isConfirmModalOpen: false },
        templatesList: templatesList,
        currentTemplate: null,
      };
    },

    [templatesDeleteFailed.toString()]: (
      state: TemplatesStates,
      action: any,
    ) => {
      return { ...state, meta: { ...state.meta, delete: 'failed' } };
    },

    [templatesUpdate.toString()]: (state: TemplatesStates, action: any) => {
      return { ...state, meta: { ...state.meta, update: 'loading' } };
    },

    [templatesUpdateSucceeded.toString()]: (
      state: TemplatesStates,
      action: any,
    ) => {
      const index = state.templatesList.findIndex(
        (template: any) => template.name === state.currentTemplate.name,
      );

      if (index > -1) {
        const templatesList = state.templatesList.slice();
        const template = Object.assign({}, state.templatesList[index]);
        if (template !== undefined) {
          templatesList[index] = Object.assign({}, action.payload.data);

          return {
            ...state,
            meta: { ...state.meta, update: 'succeeded' },
            ui: { ...state.ui, isEditModalOpen: false },
            templatesList: templatesList,
          };
        }
        return {
          ...state,
          meta: { ...state.meta, update: 'succeeded' },
          ui: { ...state.ui, isEditModalOpen: false },
        };
      }
      return {
        ...state,
        meta: { ...state.meta, update: 'succeeded' },
        ui: { ...state.ui, isEditModalOpen: false },
      };
    },

    [templatesUpdateFailed.toString()]: (
      state: TemplatesStates,
      action: any,
    ) => {
      return { ...state, meta: { ...state.meta, update: 'failed' } };
    },

    [templatesRender.toString()]: (state: TemplatesStates, action: any) => {
      return { ...state, meta: { ...state.meta, render: 'loading' } };
    },

    [templatesRenderSucceeded.toString()]: (
      state: TemplatesStates,
      action: any,
    ) => {
      return { ...state, meta: { ...state.meta, render: 'succeeded' } };
    },

    [templatesRenderFailed.toString()]: (
      state: TemplatesStates,
      action: any,
    ) => {
      return { ...state, meta: { ...state.meta, render: 'failed' } };
    },
  },
  initialState,
);
